import React from "react"

import { ContentQuery } from '../core'
import TextContent from './TextContent'
import Link from './Link'
import Form from './Form'
import MembershipsList from './MembershipsList'
import MembershipsCatalog from './MembershipsCatalog'
import InstagramFeed from './InstagramFeed'
import BlogFeed from './BlogFeed'
import LocationsList from './LocationsList'
import EnterpriseInquiry from './EnterpriseInquiry'

const Widget = ({ data = {}, ...rest }) => {
  const { type } = data

  switch (type) {
  case 'Memberships List':
    return <MembershipsList data={data} {...rest} />
  case 'Memberships Catalog':
    return <MembershipsCatalog data={data} {...rest} />
  case 'instagram-feed':
    return <InstagramFeed data={data} {...rest} />
  case 'blog-feed':
    return <BlogFeed data={data} {...rest} />
  case 'locations-list':
    return <LocationsList data={data} {...rest} />
  case 'enterprise-inquiry':
    return <EnterpriseInquiry data={data} {...rest} />
  default:
    return <div>widget: {type}</div>
  }
}

const getContent = (typename) => {
  switch (typename) {
  case 'ContentfulContentText':
    return TextContent
  case 'ContentfulContentForm':
    return Form
  case 'ContentfulContentWidget':
    return Widget
  case 'ContentfulContentLink':
    return Link
  default: 
    return () => (<div>{typename}</div>)
  }
}

const Content = ({ typename, id, ...rest }) => {
  return (
    <ContentQuery
      id={id}
      render={getContent(typename)}
      {...rest}
    />
  )
}

export default Content